import React, { memo, useEffect, useState } from "react";
// import { useDebounce } from "util";
import { SearchCountries } from "../../../slice/userThunks";
import { selCountriesInUser } from "../../../slice/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import { FormControl, FormLabel, makeStyles } from "@material-ui/core";
import { TextField } from "app/components/common/TextField";
import { getAllCountries } from "store/slices/thunks";
import { selBaseCountries } from "store/slices";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { globalStyles } from "containers/themes/globalClasses";

/* -------------------------------------------------------------------------- */
export const PhoneSelector = memo(
  ({
    label,
    onChange,
    error,
    helperText,
    className,
    disabled,
    required,
    value,
  }) => {
    const classes = useStyles();

    return (
      <FormControl
        error={Boolean(error)}
        required={required}
        fullWidth
        className={`${classes.formControl} ${className}`}
      >
        {label && <FormLabel>{label}</FormLabel>}
        <PhoneInput
          disabled={disabled}
          onChange={(value, data) => {
            onChange({
              code: data.dialCode,
              number: value.slice(data.dialCode?.length || 0),
            });
          }}
          value={value?.code + value?.number}
          helperText={helperText}
          inputStyle={{ width: "100%" }}
          specialLabel=""
        />
      </FormControl>
    );
  }
);
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  formControl: {
    ...globalStyles(theme).formControl,
    width: "100%",
  },
}));
